import React from 'react';
import { OutlinedIcons } from '@marageti/z4-lib';
import { useAuthStore } from '../../store';
import { HomeLink } from './types';
import HomeView from './home-view';

const {
  OutlinedCogIcon,
  OutlinedInboxInIcon,
  OutlinedStarIcon,
  OutlinedDuplicateIcon,
  OutlinedBriefcaseIcon,
  OutlinedUserCircleIcon,
  OutlinedClipboardCheckIcon,
} = OutlinedIcons;

const HOME_LINKS: HomeLink[] = [
  {
    title: 'Trip Requests',
    subTitle: 'Match incoming requests',
    href: '/trip-requests',
    icon: <OutlinedInboxInIcon sx={{ width: '23px' }} />,
  },
  {
    title: 'Reviews',
    subTitle: 'View & search reviews',
    href: '/reviews',
    icon: <OutlinedStarIcon sx={{ width: '23px' }} />,
  },
  {
    title: 'Trip Matches',
    subTitle: 'View & search matched trips',
    href: '/trip-matches',
    icon: <OutlinedDuplicateIcon sx={{ width: '23px' }} />,
  },
  {
    title: 'Partners',
    subTitle: 'View & search active partners',
    href: 'partners',
    icon: <OutlinedBriefcaseIcon sx={{ width: '23px' }} />,
  },
  {
    title: 'Sales',
    subTitle: 'View & search sales',
    href: '/sales',
    icon: <OutlinedCogIcon sx={{ width: '23px' }} />,
  },
  {
    title: 'Travelers',
    subTitle: 'View & search travelers',
    href: '/travelers',
    icon: <OutlinedUserCircleIcon sx={{ width: '23px' }} />,
  },
  {
    title: 'Settings',
    subTitle: 'Manage profile & app settings',
    href: 'settings',
    icon: <OutlinedCogIcon sx={{ width: '23px' }} />,
  },
  {
    title: 'Tickets',
    subTitle: 'Manage issues and tickets',
    href: '/tickets',
    icon: <OutlinedClipboardCheckIcon sx={{ width: '23px' }} />,
  },
];

const HomeContainer = () => {
  const {
    loggedInTeamMember,
  } = useAuthStore();

  const today = new Date();
  const formatedDate = today.toLocaleString('en-US', {
    weekday: 'long',
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });

  return (
    <HomeView
      links={HOME_LINKS}
      date={formatedDate}
      givenName={loggedInTeamMember?.givenName || ''}
    />
  );
};

export default HomeContainer;
